import { computed, Directive, HostBinding, inject, input, OnInit, output, signal } from '@angular/core';

import { CollectionFilter } from '../../../models/collection-filter.type';
import { CollectionFilteringStore } from '../../../state/collection-filtering.store';
import { CollectionFilterValue } from '../../../models/collection-filter-value.type';

@Directive({
  selector: '[ciphrCollectionFilter]',
  standalone: true,
})
export class CollectionFilterDirective implements OnInit {
  private readonly collectionFilteringStore = inject(CollectionFilteringStore);

  expanded = input.required<boolean>();
  filter = input.required<CollectionFilter>();

  expansionToggle = output();
  valuesSelectionChange = output<{ values: CollectionFilterValue['value'][] }>();

  @HostBinding('class.expanded') get expandedClass() {
    return this.expanded();
  }

  private readonly filterActiveValues = computed(
    () => this.collectionFilteringStore.activeFilters().find((filter) => filter.key === this.filter().key)?.values,
  );
  private readonly selectedValuesSource = signal<Set<CollectionFilterValue['value']>>(new Set());
  selectedValues = this.selectedValuesSource.asReadonly();

  ngOnInit(): void {
    this.selectedValuesSource.set(new Set(this.filterActiveValues()));
  }

  clearSelectedValues(): void {
    this.selectedValuesSource.set(new Set());
    this.valuesSelectionChange.emit({ values: [] });
  }

  setValuesSelection(values: CollectionFilterValue['value'][]): void {
    this.selectedValuesSource.set(new Set(values));
    this.valuesSelectionChange.emit({ values: Array.from(this.selectedValuesSource()) });
  }

  toggleExpansion(): void {
    this.expansionToggle.emit();
  }

  toggleValueSelection(value: CollectionFilterValue['value']): void {
    this.selectedValuesSource.update((selectedValues) => {
      selectedValues.has(value) ? selectedValues.delete(value) : selectedValues.add(value);
      return selectedValues;
    });

    this.valuesSelectionChange.emit({ values: Array.from(this.selectedValuesSource()) });
  }
}
